<script lang="ts" setup>
import { ref, inject, computed, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { useFetch } from '@/helpers/composables/useFetch';
import NProgress from 'nprogress';
import RothcoCta from '@/components/RothcoCta.vue';
import Bell from '@icons/bell.svg';
const props = defineProps({
        api_key: {
            type: Object,
            default: () => ({
                key: ""
            }),
            required: false
        },
        allow_generate_key: {
            type: Boolean,
            default: false,
            required: false
        },
        graphQl: {
            type: Boolean,
            default: false,
            required: false
        },
        hasTokens: {
            type: Boolean,
            default: false,
            required: false
        }
});

let route = inject('route');
const graphQl = computed(() => props.graphQl);

const generateApiKeyLoading = ref(false);
let generateApiKey: (() => Promise<any> | void) | null = null;

if (!graphQl.value) {
    const fetchChain = useFetch(route('apikey.generate'), {
        immediate: false,
        beforeFetch: (ctx) => {
            let { cancel } = ctx;
            
            if(generateApiKeyLoading.value){
                cancel();
            }
            NProgress.start();
            generateApiKeyLoading.value = true;

            ctx.options.headers = {
                ...ctx.options.headers,
                'Accept': 'application/json',
            }
            return ctx;
        },
        afterFetch: (ctx) => {
            generateApiKeyLoading.value = false
            NProgress.done();
            if(ctx.response.ok){
               apiKey.value = ctx.data.data.apiKey;
            }
        },
        onFetchError: ()=>{
            generateApiKeyLoading.value = false;
        }
    }).post().json();

    generateApiKey = fetchChain.execute;
}

const generateApiKeyFetch = () => {
    if (graphQl.value || generateApiKeyLoading.value) return;
    generateApiKey?.();
};

const apiKey = ref(usePage().props?.api_key?.key ?? props.api_key?.key ?? '');

let showGenerateLink = computed(() => {
    return props.allow_generate_key && !graphQl.value;
});

let apiTokenUrl = computed(() => {
    return route('account.apiTokens');
});
</script>
<template>
    <div class="api-settings-container-key">
        <div v-if="!graphQl">
            <span class="title-s">API key:</span>
            <span class="title-s" id="apiKey">{{ apiKey }}</span>
            
            <a
                v-if="showGenerateLink"
                @click.prevent="generateApiKeyFetch"
                href="#"
                aria-label="Generate a new API Key"
            >
                Generate New API Key
            </a>
        </div>
        <div v-else class="graphql-cta">
            <span class="title-s flex-row align-center">
                <Bell class="alert-icon" alt="bell icon" />
                <RothcoCta cta-type="link" :href="apiTokenUrl">{{ hasTokens ? "Manage your tokens" : "Create new API token!" }}</RothcoCta>
            </span>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.alert-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
}
</style>
